import React, { Children, memo } from 'react';
import { motion } from 'framer-motion';
const stepVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15
    }
  }
};
const stepItem = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
export function ProcessSection() {
  return <section className="px-4 py-20 md:py-28 bg-midnight-900/50" data-id="element-187">
      <div className="max-w-3xl mx-auto" data-id="element-188">
        {/* How It Works */}
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} data-id="element-189">
          <div className="border-t-2 border-rescue-gold/40 w-16 mb-6" aria-hidden="true" data-id="element-190" />
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-white mb-12" data-id="element-191">
            How It Works
          </h2>
        </motion.div>

        <motion.div variants={stepVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-40px'
      }} className="relative" data-id="element-192">
          {/* Connecting line */}
          <div className="absolute left-[22px] top-[44px] bottom-[44px] w-px bg-gradient-to-b from-rescue-gold/30 via-rescue-gold/15 to-transparent hidden md:block" aria-hidden="true" data-id="element-193" />

          <div className="space-y-10" data-id="element-194">
            <motion.div variants={stepItem} className="flex items-start gap-6" data-id="element-195">
              <div className="flex-shrink-0 w-11 h-11 rounded-full bg-rescue-gold text-midnight-950 flex items-center justify-center font-heading font-bold text-lg" data-id="element-196">
                1
              </div>
              <div data-id="element-197">
                <h3 className="font-body text-xl font-bold text-white mb-2" data-id="element-198">
                  The Bypass
                </h3>
                <p className="font-body text-gray-400 leading-relaxed" data-id="element-199">
                  Use the guide to jump straight to the 100% free IRS-verified
                  portals (no credit card required).
                </p>
              </div>
            </motion.div>

            <motion.div variants={stepItem} className="flex items-start gap-6" data-id="element-200">
              <div className="flex-shrink-0 w-11 h-11 rounded-full bg-rescue-gold text-midnight-950 flex items-center justify-center font-heading font-bold text-lg" data-id="element-201">
                2
              </div>
              <div data-id="element-202">
                <h3 className="font-body text-xl font-bold text-white mb-2" data-id="element-203">
                  The Sprint
                </h3>
                <p className="font-body text-gray-400 leading-relaxed" data-id="element-204">
                  Follow the screen-by-screen checklist to enter your income and
                  deductions in under an hour.
                </p>
              </div>
            </motion.div>

            <motion.div variants={stepItem} className="flex items-start gap-6" data-id="element-205">
              <div className="flex-shrink-0 w-11 h-11 rounded-full bg-rescue-gold text-midnight-950 flex items-center justify-center font-heading font-bold text-lg" data-id="element-206">
                3
              </div>
              <div data-id="element-207">
                <h3 className="font-body text-xl font-bold text-white mb-2" data-id="element-208">
                  The Submission
                </h3>
                <p className="font-body text-gray-400 leading-relaxed" data-id="element-209">
                  Hit 'Submit' with the confidence that you are 100% compliant
                  and $0 poorer.
                </p>
              </div>
            </motion.div>
          </div>
        </motion.div>

        {/* The 7-Day Identity Shift */}
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} className="mt-16" data-id="element-210">
          <div className="border-l-4 border-rescue-gold/50 pl-6 py-2" data-id="element-211">
            <h3 className="font-heading text-2xl md:text-3xl font-bold text-white mb-4" data-id="element-212">
              The 7-Day Identity Shift
            </h3>
            <p className="font-body text-base md:text-lg text-gray-300 leading-relaxed" data-id="element-213">
              Seven days from now, your taxes will be a memory. Instead of a
              "Notice of Intent to Levy" in your mailbox, you'll have a
              confirmation number from the IRS and the{' '}
              <span className="text-rescue-green font-semibold" data-id="element-214">
                $120 you saved
              </span>{' '}
              still sitting in your bank account.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}